exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3J6sBBuW2U96fU9-uzwxKr{position:absolute;bottom:60px;width:100%;height:400px;overflow-wrap:normal;white-space:normal}html[dir=ltr] ._3J6sBBuW2U96fU9-uzwxKr{left:0}html[dir=rtl] ._3J6sBBuW2U96fU9-uzwxKr{right:0}.mIO4tnFNcG92bnbuWaXJL{display:none}._3g3sF2w7mhgGaolxKsEoqk{height:18px;width:18px}html[dir] ._3g3sF2w7mhgGaolxKsEoqk.ms-Button{padding:0}._3g3sF2w7mhgGaolxKsEoqk.ms-Button .ms-Icon{font-size:14px}html[dir] ._3g3sF2w7mhgGaolxKsEoqk.ms-Button .ms-Icon{margin:0}", ""]);
// Exports
exports.locals = {
	"chatContainer": "_3J6sBBuW2U96fU9-uzwxKr",
	"chatInactive": "mIO4tnFNcG92bnbuWaXJL",
	"rightIcon": "_3g3sF2w7mhgGaolxKsEoqk"
};